"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationTarget = exports.OfferingIntent = void 0;
var OfferingIntent;
(function (OfferingIntent) {
    OfferingIntent["SHOW_DETAILS"] = "showDetails";
    OfferingIntent["BOOK_OFFERING"] = "bookOffering";
})(OfferingIntent = exports.OfferingIntent || (exports.OfferingIntent = {}));
var NavigationTarget;
(function (NavigationTarget) {
    NavigationTarget["CALENDAR"] = "calendar";
    NavigationTarget["SERVICE_PAGE"] = "servicePage";
})(NavigationTarget = exports.NavigationTarget || (exports.NavigationTarget = {}));
//# sourceMappingURL=navigation.const.js.map